module.exports = __webpack_public_path__ + "img/ustawienia.4f44efed.svg";